<template>
  <v-card outlined class="full-height">
    <div
      v-if="modelValue.Website && modelValue.Website.url"
      class="d-flex justify-center align-center ma-4"
      style="position: relative; height: 200px"
    >
      <iframe class="website-preview" :src="`${modelValue.Website.url}`" />
    </div>

    <v-card-text>
      <v-tooltip
        v-if=" modelValue.Website"
        location="bottom"
      >
        <template #activator="{ props }">
          <a
            v-bind="props"
            :href="modelValue.Website.url"
            target="_blank"
            @click.stop
          >
            {{ modelValue.Website.url }}
          </a>
        </template>
        <span>Open</span>
      </v-tooltip>
    </v-card-text>

    <v-card-text>
      <v-card class="elevation-0 ">
        <v-card-title class="text-overline pa-0 ma-0">
          Progress

          <div class="text-primary text-h3 font-weight-bold">90%</div>

          <div class="text-h6 text-medium-emphasis font-weight-regular">
            2,530 Ads
          </div>
        </v-card-title>
        <br />
        <v-card-text class="pa-0 ma-0">
          <div
            :style="`right: calc(${review} + 8px)`"
            class="position-absolute mt-n8 text-caption text-primary"
          >
            Goal
          </div>
          <v-progress-linear
            color="primary"
            height="22"
            model-value="90"
            rounded="lg"
          >
            <v-badge
              :style="`right: ${review}`"
              class="position-absolute"
              color="white"
              dot
              inline
            ></v-badge>
          </v-progress-linear>

          <div class="d-flex justify-space-between py-3">
            <span class="text-primary font-weight-medium"> 2,530 Ads </span>

            <span class="text-medium-emphasis"> 330 left </span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-list-item
          append-icon="mdi-chevron-right"
          lines="two"
          subtitle="Details and agreement"
          link
        ></v-list-item> -->
      </v-card>
    </v-card-text>

    <v-card-text>
      <v-chip-group selected-class="text-primary" column>
        <v-chip v-for="tag in Audience" :key="tag">
          {{ tag.name }}
        </v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions class="card-actions-bottom">
      <v-btn outlined text @click="() => $emit('onDetails', modelValue)">
        View Details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
    
    
  <script>
import moment from "moment";

export default {
  components: {},
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      review: "10%",
    };
  },
  computed: {
    Audience() {
      return this.modelValue && this.modelValue.Audience
        ? [
          ...this.modelValue.Audience.Languages.map(
              (audience) => audience.Language
            ),
            ...this.modelValue.Audience.Countries.map(
              (audience) => audience.Country
            ),
            ...this.modelValue.Audience.Ages.map(
              (audience) => audience.Category
            ),
            ...this.modelValue.Audience.Genders.map(
              (audience) => audience.Category
            ),
            ...this.modelValue.Audience.Interests.map(
              (audience) => audience.Category
            ),
          ]
        : [];
    },
  },
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
  },
};
</script>
    
    

<style lang="scss" scoped>
.website-preview {
  transform: scale(calc(100% / 4));
  transform-origin: top left;
  width: calc(100% * 4);
  height: 800px;
  border: none;
  position: absolute;
  left: 0;
  top: 0;
}
</style>